import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { parseStringTemplate } from '../../helpers/parse-string-template.helper';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { InfoComponentModel } from './info.model';

@Component({
  selector:    'gsm-info',
  templateUrl: './gsm-info.component.html',
  styleUrls:   ['./gsm-info.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatIcon,
    NgClass
  ]
})
export class GsmInfoComponent extends CustomDynamicFormControlComponent<InfoComponentModel> implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  get content() {
    return parseStringTemplate(this.model.content, this.model.contentValues);
  }
}
